// @ts-nocheck
import ga from "@store/Framework/Common/GoogleAnalytics";

const clearEventData = (value: any) => {
    if (typeof window !== "undefined" && window.dataLayer && typeof value === "object" && value !== null) {
        const name = ga.util.getEventPropertyName(value.event);

        if (value[name]) {
            const clear: any = { isClear: true };
            clear[name] = null;

            ga.push(clear);
        }
    }
};

export default clearEventData;
